var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrs-v-number',{staticClass:"mr-4",attrs:{"label":_vm.valueItem.label,"format":_vm.format,"errors":_vm.validationErrors,"hint":_vm.hint1,"stack-label":"","outlined":"","dense":""},on:{"input":_vm.emitInputEvent,"deletion-detected":_vm.deletionDetected},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }